/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getNotice: state => (id) => state.notices.find((notice) => notice.id == id),
  // getNotice: state => (id) => state.notices.find((notice) => notice.id == id)
  filteredNotice: state => state.notices.filter((notice) => {
    if(notice.name.toLowerCase().includes(state.noticeSearchQuery.toLowerCase()) || notice.title.toLowerCase().includes(state.noticeSearchQuery.toLowerCase()) ||
      notice.update_time.toLowerCase().includes(state.noticeSearchQuery.toLowerCase()) || notice.detail.toLowerCase().includes(state.noticeSearchQuery.toLowerCase())){
      return true
    }
    var val = notice.file_names.filter((file) => {
      return (file.toLowerCase().includes(state.noticeSearchQuery.toLowerCase()))
    })
    if(val.length != 0){
      return true
    }    
    return false
  }),
}
